import * as React from 'react';
import { Routes, Route } from 'react-router-dom';

import Home from './Home';
import Game from './Game';
import Preregistration from './Prepegistration';
import Story from './Story';

export default function App() {
    return (
        <div className="App">
            <Routes>
                <Route path="/" element={<Preregistration />} />
                <Route path="demo" element={<Home />} />
                <Route path="start/:storyId" element={<Home />} />
                <Route path="session/:userId" element={<Home />} />
                <Route path="prompt-version/:versionId" element={<Home />} />
                <Route path="game/:gameId" element={<Game />} />
                <Route path="story/:storyId" element={<Story />} />
            </Routes>
        </div>
    );
}
